import { FC } from 'react'
import { UserProtectedRoute } from 'routes'
import AdditionalServicesAnnexes from 'components/AdditionalServices/AdditionalServicesAnnexes'

const AdditionalServicesAnnexesPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesAnnexes />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesAnnexesPage
